import { createReducer, createSelector, on } from '@ngrx/store';
import { AvailableLanguages, InhLanguage } from 'src/app/shared/constants-and-enums/language';
import { getCurrentLanguageFromLocale } from 'src/app/shared/utils';
import { ChangeLanguage } from '../actions/language.actions';
import { AppState } from '../store';

export interface LanguageState {
    selectedLanguage: InhLanguage;
    languages: InhLanguage[];
    error: any;
}

export const initialState: LanguageState = {
    selectedLanguage: getCurrentLanguageFromLocale(),
    languages: AvailableLanguages,
    error: undefined
};

export const languageReducer = createReducer(
    initialState,
    on(ChangeLanguage, (state, { language }) => ({ ...state, selectedLanguage: language }))
);

export const languageState = (state: AppState) => state.languageState;
export const error = createSelector(languageState, (state) => state.error);
export const selectedLanguage = createSelector(languageState, (state) => state.selectedLanguage);
export const languages = createSelector(languageState, (state) => state.languages);
